<template>
  <Container type="card-full">
    <div slot="header">
      <el-button  @click="addDocgen">新增</el-button>
      <el-button  @click="delDocgen">删除</el-button>
      <el-button  @click="genDocgencol">生成列定义</el-button>
      <el-button  @click="sortDocgen">重新排序</el-button>
      <el-button  @click="close">关闭</el-button>
    </div>
    <div class="container">
      <vggrid ref="xGrid" class="vggrid" :list="list" tableheight="700" docgenname=""
              :cols="cols"
              :showfooter="false"
              :showPage="false" :resizable="true"
              @cellClick="cellClick"></vggrid>

      <el-form :model="form" ref="form"  class="content ss-fl" v-if="docgenform">
        <el-row>
          <el-col :span="5">
            <el-form-item label="序号" :label-width="formLabelWidth">
              <el-input v-model="form.docgenseq" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="单据生成代号" :label-width="formLabelWidth">
              <el-input v-model="form.docgencode" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="单据生成名称" :label-width="formLabelWidth">
              <el-input v-model="form.docgenname" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="数据源" :label-width="formLabelWidth">
              <el-select v-model="form.docgendsid" :clearable="true" >
                <el-option v-for="(item, index) in dsList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="" :label-width="formLabelWidth">
          <el-button type="primary" @click="saveDocgen">保存</el-button>
          <el-button type="danger" @click="delDocgen">删除</el-button>
        </el-form-item>
      </el-form>
    </div>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  export default {
    name: 'docgenIndex',
    data () {
      return {
        list: [],
        docgenform: false,
        docgenDsList: [],
        flex: this.$route.params.form,
        cols: [
          { field: 'docgenseq', title: '序号',calculExpr:'', addNewRowFlg: false},
          { field: 'docgenname', title: '单据生成名称',calculExpr:'',addNewRowFlg: false},
        ],
        form: {},
        loading: true,
        formLabelWidth: '100px'
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getDocgenList()
      this.getDsList()
    },
    mounted () {
    },
    components: {vggrid},
    methods: {
      async init() {
        this.list = []
        this.docgenform = false
        this.dsList = []
        this.flex = this.$route.params.form
        this.form = {}
      },
      async addDocgen () {
        this.docgenform = true
        let maxSeq = 0
        this.list.forEach(item => {
          if (item.docgenseq>maxSeq) {
            maxSeq = item.docgenseq
          }
        })
        maxSeq += 10
        this.form = {
          docgenid: 0,
          docgenseq: maxSeq,
          docgencode: '',
          docgenname: '',
          docgendsid: ''
        }
      },
      async getDsList() {
        this.dsList = await request({
          url: '/xtgl/ds/getDsList',
          method: "get",
          params: {comid:this.$store.getters.loginUser.usercomid}
        })
      },
      async genDocgencol() {
        if (!this.form.docgenid) {
          this.$message.warning('请选择一条数据!')
          return
        }
        this.$router.push({name: 'docgencolForm', params: {form: this.form}})
      },
      async sortDocgen () {
        let data = await request({
          url: '/kfgl/docgen/sortDocgen',
          method: "post",
          data: this.list
        })
        if (data.issuccess === 1) {
          this.getDocgenList()
          this.$message.success('排序成功！')
        } else {
          this.$message.error('排序失败！')
        }
      },
      async delDocgen () {
        console.log(this.fc)
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/kfgl/docgen/delDocgen',
            method: "post",
            data: this.form
          })
          if (data.issuccess === 1) {
            this.getDocgenList()
            this.$message.success('删除成功！')
          }
        })
      },
      async saveDocgen () {
        this.form.docgenflexid = this.flex.flexid
        await request({
          url: '/kfgl/docgen/addOrEdit',
          method: "post",
          data: this.form
        })
        this.$message.success('操作成功')
        await this.getDocgenList()
        this.docgenform = false
      },
      async cellClick (row) {
        this.form = row.row
        this.docgenform = true
      },
      async getDocgenList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/docgen/getDocgenList',
          params: {flexid: this.flex.flexid}
        })
        this.list = res
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'flexIndex'})
      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    .vggrid {
      border: 1px solid #d1dbe5;
      width: 400px;
      margin-right: 5px;
    }
    .content {
      width: 100%;
      padding-top: 10px;
      padding-right: 10px;
      border: 1px solid #d1dbe5;
    }
  }
  #menuReportDiv {
    height: 380px;
    overflow: auto;
  }
</style>
